<template>
    <va-edit-layout>
        <FinancialTransactionSummary-form
            :id="id"
            :title="title"
            :item="item"
        ></FinancialTransactionSummary-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
